import { render, staticRenderFns } from "./FeatureNotAvailableDialog.vue?vue&type=template&id=28ba1034&"
import script from "./FeatureNotAvailableDialog.vue?vue&type=script&lang=ts&"
export * from "./FeatureNotAvailableDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports